import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCartStore } from '../../../store/cart';
import { useGlobalStore } from '../../../store/global';
import { formatPrice } from '../../../utils';
import { useModalStore } from "@/store/modal";
import CartDeliveryPlaces from "@/components/cart/summary/cart-delivery-places";
import CartCalendar from "@/components/cart/summary/cart-calendar";
function CartShipment({ shipment }) {
    const currency = useGlobalStore((state) => state.config.currency);
    const activeShipment = useCartStore((state) => state.activeShipment);
    const setActiveShipment = useCartStore((state) => state.setActiveShipment);
    const activePlaceOfDelivery = useCartStore((state) => state.activePlaceOfDelivery);
    const deliveryTime = useCartStore((state) => state.deliveryTime);
    const isActive = activeShipment?.id === shipment.id;
    const shipmentPrice = shipment.finalPrice === 0 ? 'ZDARMA' : formatPrice(shipment.finalPrice, currency);
    const handleShipmentClick = () => {
        setActiveShipment(shipment);
    };
    return (_jsxs("div", { onClick: handleShipmentClick, className: `shipment d-flex flex-column ${isActive ? 'active' : ''}`, children: [_jsxs("div", { className: "d-flex align-items-center", children: [_jsx("input", { id: `shipment-${shipment.id}`, type: "radio", checked: isActive, disabled: true }), _jsx("label", { htmlFor: `shipment-${shipment.id}` }), _jsx("img", { className: "ml-2", src: shipment.image.url, alt: shipment.image.alt }), _jsx("span", { className: "ml-2", children: shipment.title }), _jsx("span", { className: "price", children: shipmentPrice })] }), shipment?.is_delivery_place_shipment && (_jsxs("div", { className: "mt-1", children: [activePlaceOfDelivery && (_jsx("span", { className: "mr-2", children: activePlaceOfDelivery.address })), deliveryTime && (_jsx("span", { children: deliveryTime.format('DD.MM.YYYY') }))] }))] }));
}
export default function CartShipments() {
    const activePayment = useCartStore((state) => state.activePayment);
    const activeShipment = useCartStore((state) => state.activeShipment);
    const texts = useGlobalStore((state) => state.config.texts);
    const open = useModalStore((state) => state.open);
    const deliveryPlaces = useCartStore((state) => state.cart.deliveryPlaces);
    if (!activePayment || activePayment.shipments.length === 0) {
        return null;
    }
    const openCalendar = () => {
        return open({
            title: texts['text538'],
            content: _jsx(CartCalendar, {}),
            extraClass: 'w-75'
        });
    };
    const openDeliveryPlaces = () => {
        return open({
            title: texts['text440'],
            content: _jsx(CartDeliveryPlaces, { deliveryPlaces: deliveryPlaces }),
            extraClass: 'w-75'
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "shipments d-flex flex-column", children: activePayment.shipments.map((shipment, i) => (_jsx("div", { className: `${i > 0 ? 'mt-2' : ''}`, children: _jsx(CartShipment, { shipment: shipment }) }, `shipment-${i}`))) }), activeShipment?.is_delivery_place_shipment && (_jsx("div", { className: "mt-4", children: _jsxs("div", { className: "d-flex flex-column", children: [_jsxs("button", { className: "primary", type: "button", onClick: openDeliveryPlaces, children: [_jsx("i", { className: "fas fa-location-arrow mr-2" }), texts['text440']] }), _jsxs("button", { className: "primary mt-2", type: "button", onClick: openCalendar, children: [_jsx("i", { className: "fas fa-calendar mr-2" }), texts['text538']] })] }) }))] }));
}
